import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import type { ImageBlockConfiguration } from "models/interfaces/block-configurations/image-block-configuration";
import {
    blockConfigurationDefaultValuesFactory,
    BlockConfigurationRecord,
} from "models/view-models/block-configurations/block-configuration-record";
import FileRecord from "../file-record";
import { ImageAnnotationRecord } from "./image-annotation-record";

const defaultValues: ImageBlockConfiguration =
    blockConfigurationDefaultValuesFactory<ImageBlockConfiguration>({
        imageFile: undefined,
        imageFileId: 0,
        size: undefined,
        position: undefined,
        annotations: [],
    });

export class ImageBlockConfigurationRecord
    extends Record(defaultValues)
    implements ImageBlockConfiguration, BlockConfigurationRecord
{
    constructor(params?: Partial<ImageBlockConfiguration>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.imageFile != null) {
            params.imageFile = RecordUtils.ensureRecord(
                params.imageFile,
                FileRecord
            );
        }

        if (params.annotations != null) {
            params.annotations = params.annotations.map((annotation) =>
                RecordUtils.ensureRecord(annotation, ImageAnnotationRecord)
            );
        }

        super(params);
    }

    public with(
        values: Partial<ImageBlockConfiguration>
    ): ImageBlockConfigurationRecord {
        return new ImageBlockConfigurationRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
